import { List } from 'antd';
import React from 'react';
import { arrayOf, shape } from 'prop-types';
import CommentItem from './CommentItem';

const CommentList = ({ comments = [] }) => (
  <List
    dataSource={comments}
    header={`${comments.length} ${comments.length > 1 ? 'comments' : 'comment'}`}
    renderItem={(item) => <CommentItem {...item} />}
  />
);

CommentList.propTypes = {
  comments: arrayOf(shape({})),
};

export default CommentList;
